import React, { FunctionComponent, useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { IDoughnutChartProps } from './types';

const DoughnutChart: FunctionComponent<IDoughnutChartProps> = ({ segments, completionRate }) => {
  const colors = useMemo(() => {
    const root = getComputedStyle(document.documentElement);
    return {
      red: root.getPropertyValue('--chart-red').trim(),
      green: root.getPropertyValue('--chart-green').trim(),
      orange: root.getPropertyValue('--chart-orange').trim(),
      gray: root.getPropertyValue('--chart-gray').trim(),
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: 120, height: 120 }}>
      <Doughnut
        data={{
          datasets: [
            {
              label: 'My First Dataset',
              data: completionRate != null ? segments.map((segment) => segment.value) : [100],
              backgroundColor:
                completionRate != null ? segments.map((segment) => colors[segment.color]) : [colors.gray],
            },
          ],
        }}
        options={{
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              enabled: false,
            },
          },
        }}
        width={100}
        height={100}
      />
      <div
        style={{
          position: 'absolute',
          top: '52%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '20px',
          fontWeight: 'bold',
          color: '#333',
        }}
      ></div>
    </div>
  );
};
export default DoughnutChart;
